import config from './config'

export const baseTheme = {
  config,
}
